var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{key:_vm.isSelected,staticClass:"connection-container",class:{ 'elevation-2': _vm.isSelected, lastTube: _vm.lastTube},style:({
    'background-color': _vm.isSelected ? 'lightgrey' : 'none'
  }),on:{"click":_vm.click,"contextmenu":function($event){return _vm.$emit('contextmenu', $event)}}},[_c('v-layout',{attrs:{"align-center":"","justify-end":_vm.justifyEnd}},[_vm._t("default")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17084454","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Splicing/ObjectTable/TableDataConnectionPoint.vue
// module id = null
// module chunks = 